// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_Saf","cls2":"AvatarCell-cls2_1ob AvatarCell-cls1_Saf"};